import styled from 'styled-components';

import { Checkbox as UnstyledCheckbox } from 'components/CheckboxGroup';
import { Bar } from 'components/CheckboxGroup/styles';

export const Checkbox = styled(UnstyledCheckbox)`
	${Bar} {
		padding: 0;
		min-height: 20px;
	}
`;
